import {ICommonGallery} from "../interfaces";

interface ICommonGalleryProps {
    commonGalleryProps: ICommonGallery,
}
/**
 * the entry point
 */
const ProductCommonGalleryTitle = (props: ICommonGalleryProps) => {

    const commonGalleryProps = props.commonGalleryProps;
    let textProductPlugins = "";

    switch(commonGalleryProps.urlPathName){
        case 'bundles':
        case 'subscriptions':{
            if(commonGalleryProps.dataTab === 'tab-included-in')
                textProductPlugins = `Included in ${commonGalleryProps?.totalProducts} Plugins`;
            else
                textProductPlugins = commonGalleryProps?.totalProducts +  ' Plugins Included';
            break;
        }
        case 'mixers-racks':
        case 'hardware':
        case 'plugins':{
            if(commonGalleryProps.dataTab === 'tab-included-in')
                textProductPlugins = `Included in ${commonGalleryProps?.totalProducts} Products`;
            else
                textProductPlugins = commonGalleryProps?.totalProducts +  ' Products Included';
            break;
        }
        case 'courses':{
            textProductPlugins = commonGalleryProps?.totalProducts + ' Plugins Featured in This Course';
            break;
        }
    }
    return (

            <>
                    <div className="waves-h2 pb-8 md:pb-12 pt-8 text-center">{textProductPlugins}</div>
            </>
    )
};

export default ProductCommonGalleryTitle;